import { keyframes } from 'styled-components/macro';

const OFFSET = 8;

export const overlaySlideInTop = keyframes`
  from { opacity: 0; transform: translateY(${OFFSET}px); }
  to { opacity: 1; transform: translateY(0);}
`;

export const overlaySlideOutTop = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(${OFFSET}px);
  }
`;

export const overlaySlideInBottom = keyframes`
  from {
    opacity: 0;
    transform: translateY(-${OFFSET}px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const overlaySlideOutBottom = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-${OFFSET}px);
  }
`;

export const overlaySlideInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(${OFFSET}px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const overlaySlideOutLeft = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(${OFFSET}px);
  }
`;

export const overlaySlideInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(-${OFFSET}px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const overlaySlideOutRight = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-${OFFSET}px);
  }
`;
